export const changePassword = {
    title: 'Сменить пароль',
    oldPasswordLabel: 'Старый пароль',
    newPasswordLabel: 'Новый пароль',
    confirmPasswordLabel: 'Подтвердите новый пароль',
    password: 'Пароль',
    save: 'Сохранить изменения',
    cancel: 'Отмена',
};
